import { PAYMENT_OPTIONS } from 'constants/payment'
import { createSelector } from 'reselect'

export const isUsingCredit = (state: App.State) => state.checkout.payment.useCredit

export const isReserveForFreeSelected = (state: App.State) =>
  state.checkout.payment.paymentSelected === PAYMENT_OPTIONS.RESERVE_FOR_FREE

export const isUsingGiftCard = createSelector(
  (state: App.State) => state.checkout.payment.useGiftCard,
  (state: App.State) => isReserveForFreeSelected(state),
  (state: App.State) => state.checkout.payment.partnerships.velocity?.burn?.isApplied,
  (useGiftCard, isReserveForFreeSelected, isVelocityApplied) =>
    useGiftCard && !isReserveForFreeSelected && !isVelocityApplied,
)
